/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { ShareButtons, generateShareIcon } from 'react-share';
import styled from 'styled-components';

// Components
import Piace from '../common/Piace';

// Messages
import messages from './messages/ReportPaidHeader_messages';

const propTypes = {
  hasPiaced: PropTypes.bool,
  intl: intlShape.isRequired,
  partners: PropTypes.array,
  piaceCount: PropTypes.number,
  savePiace: PropTypes.func,
};

const defaultProps = {
  hasPiaced: false,
  partners: [],
  piaceCount: 0,
  savePiace: () => {},
};

const ReportHeader = ({
  hasPiaced, intl, partners, piaceCount, savePiace,
}) => {
  const { FacebookShareButton, TwitterShareButton } = ShareButtons;
  const TwitterIcon = generateShareIcon('twitter');
  const FacebookIcon = generateShareIcon('facebook');
  const reportUrl = window.location.href;

  const today = new Date();
  const day = `0${today.getDate()}`.slice(-2);
  const month = `0${today.getMonth() + 1}`.slice(-2);
  const year = today.getFullYear();
  const dateString = `${day}.${month}.${year}`;

  const partnerLogos = Object.values(partners)
  .filter(partner => partner.show_in_statement_header)
  .map(partner =>
    <a
      href={partner.url_fi}
      target="_blank"
      rel="noopener noreferrer"
      key={partner.name}
    >
      <img src={partner.logo_fi} alt={partner.name} />
    </a>
);

  return (
    <HeaderRow>
      <Social>
        <FacebookShareButton
          url={reportUrl}
          title={intl.formatMessage(messages.facebookShareTitle)}
          description={`${intl.formatMessage(
            messages.facebookShareDescription,
          )} ${reportUrl}`}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <TwitterShareButton
          title={intl.formatMessage(messages.facebookShareTitle)}
          url={reportUrl}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>

        <Piace
          hasPiaced={hasPiaced}
          piaceCount={piaceCount}
          piaceClicked={savePiace}
          short
          nowrap
        />
      </Social>

      <DateString>{dateString}</DateString>

      <Partners>
        {partnerLogos || null}
      </Partners>
    </HeaderRow>
  );
};

ReportHeader.propTypes = propTypes;
ReportHeader.defaultProps = defaultProps;

const DateString = styled.div`
  order: 1;

  @media (min-width: 480px) {
    order: 2;
    padding: 0 12px;
  }
`;

const HeaderRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: -40px;

  & > * {
    margin-bottom: 12px;
  }

  @media (min-width: 480px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between
    margin-top: -20px;

    & > * {
      margin-bottom: 0px;
    }
  }
`;

const Partners = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  line-height: 0;
  margin: -5px;
  order: 2;

  img {
    max-height: 60px;
    margin: 5px;
  }

  @media (min-width: 480px;) {
    order: 3;
  }
`;

const Social = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  order: 3;

  & > * {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (min-width: 480px) {
    order: 1;
  }
`;

export default injectIntl(ReportHeader);
